// Fresh TTS blocks for TTSView and FreeChoiceView (both had an identical
// private copy of these two helpers).

import type { Block as BlockT, TtsParams } from '@shared/types';
import { TTS_PARAMS_V2_DEFAULT, TTS_PARAMS_V4_DEFAULT } from '@shared/constants';
import { newBlockId } from '@/lib/blockId';
import { normalizeBlockText } from '@/lib/blockText';

export function defaultParams(): TtsParams {
  return {
    model: 'v2',
    v2: { ...TTS_PARAMS_V2_DEFAULT },
    v4: { ...TTS_PARAMS_V4_DEFAULT },
  };
}

export function makeEmptyBlock(text = '', voiceId = ''): BlockT {
  return {
    id: newBlockId(),
    // Skripte aus dem Admin können in NFD ankommen — beim Seed normalisieren.
    text: normalizeBlockText(text),
    params: defaultParams(),
    takes: [],
    favIdx: -1,
    takeCounter: 0,
    locked: false,
    offset: 0,
    pinned: false,
    voiceId,
  };
}
